<template>
  <b-tabs v-model="tabIndex" v-on:activate-tab="tabActivated">
    <b-tab
      :title="`${$t('menu.settings.alertsNewsletters.titleGeneral')}`"
      active
    >
      <div v-if="loading" class="text-center text-primary my-2">
        <b-spinner type="grow" class="align-middle"></b-spinner>
      </div>
      <div v-else>
        <tab-geral :actionId="actionId" />
      </div>
    </b-tab>
    <b-tab :title="`${$t('menu.settings.alertsNewsletters.titleBranch')}`">
      <tab-branch :actionId="actionId" />
    </b-tab>
  </b-tabs>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import swal from 'sweetalert';
import api from '../../../../../services/api';
import tabGeral from './tab-geral';
import tabBranch from './tab-branch';

export default {
  components: {
    tabGeral,
    tabBranch,
  },

  computed: {
    ...mapFields('alertRules', ['newRule', 'alertId', 'loadingBranches']),
    ...mapState('actions', ['action']),
  },

  watch: {
    tabIndex: function watchTabIndex() {
      if (this.tabIndex === 1) {
        this.$store.state.settings.alertRulesFooter = false;
      } else {
        this.$store.state.settings.alertRulesFooter = true;
      }
    },
  },

  props: ['actionId'],

  data: () => ({
    tabIndex: 0,
    userAuth: null,
    loading: false,
  }),

  methods: {
    ...mapActions('alertRules', ['saveRule', 'getBranchRules', 'setList']),

    async getBranches() {
      this.loadingBranches = true;
      await this.getBranchRules({
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
        mainRuleId: this.alertId,
        params: {
          limit: 10,
          page: 1,
        },
      });
      this.loadingBranches = false;
    },

    checkFooter() {
      if (this.tabIndex === 1) {
        this.$store.state.settings.alertRulesFooter = false;
      } else {
        this.$store.state.settings.alertRulesFooter = true;
      }
    },

    async tabActivated(newTabIndex, oldTabIndex, event) {
      if (!this.alertId) {
        event.preventDefault();
        if (!this.newRule.name) {
          swal({
            title: this.$t(
              'menu.settings.alertsNewsletters.messages.insertNameRule.title',
            ),
            text: this.$t(
              'menu.settings.alertsNewsletters.messages.insertNameRule.description',
            ),
            icon: 'warning',
          });
        } else {
          swal({
            title: this.$t(
              'menu.settings.alertsNewsletters.messages.ruleForBranch.title',
            ),
            text: this.$t(
              'menu.settings.alertsNewsletters.messages.ruleForBranch.description',
            ),
            icon: 'warning',
            buttons: true,
            dangerMode: true,
          }).then(async (willDelete) => {
            if (willDelete) {
              await this.saveRule({
                companyId: this.userAuth.companyId,
                token: this.userAuth.token,
                data: { ...this.newRule },
              });
              await swal({
                title: this.$t(
                  'menu.settings.alertsNewsletters.messages.successRegisterRule.title',
                ),
                text: this.$t(
                  'menu.settings.alertsNewsletters.messages.successRegisterRule.description',
                ),
                icon: 'success',
              });
              this.tabIndex = 1;
              await this.getBranches();
              this.action.alertRules.id = this.alertId;
              await this.setList({
                token: this.userAuth.token,
                companyId: this.userAuth.companyId,
              });
            }
          });
        }
      } else if (this.tabIndex === 1) {
        this.loading = true;
        await this.getNewRule();
        this.loading = false;
      } else {
        await this.getBranches();
      }
    },

    async linkClass() {
      if (this.tabIndex === 1) {
        this.$store.state.settings.alertRulesFooter = false;

        await this.getBranchRules({
          companyId: this.userAuth.companyId,
          token: this.userAuth.token,
          mainRuleId: this.alertId,
          params: {
            limit: 10,
            page: 1,
          },
        });
      } else {
        this.$store.state.settings.alertRulesFooter = true;
      }
    },

    async getNewRule() {
      const response = await api.get(
        `${process.env.API_ROOT}/alert-rule/${this.userAuth.companyId}/${this.alertId}`,
        {
          headers: { 'x-access-token': this.userAuth.token },
        },
      );
      this.newRule = response.data;
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.$store.state.settings.alertRulesFooter = true;
    this.alertId = null;

    if (
      this.$store.state.actions.action.type === 'ces-1-5' ||
      this.$store.state.actions.action.type === '5-stars'
    ) {
      this.newRule = {
        name: null,
        rules: [
          {
            email: null,
            justComment: false,
            alerts: [
              { grade: 1, value: false },
              { grade: 2, value: false },
              { grade: 3, value: false },
              { grade: 4, value: false },
              { grade: 5, value: false },
            ],
          },
        ],
        level1: {
          email: null,
          days: null,
        },
        level2: {
          email: null,
          days: null,
        },
        level3: {
          email: null,
          days: null,
        },
      };
    } else {
      this.newRule = {
        name: null,
        rules: [
          {
            email: null,
            justComment: false,
            alerts: [
              { grade: 0, value: false },
              { grade: 1, value: false },
              { grade: 2, value: false },
              { grade: 3, value: false },
              { grade: 4, value: false },
              { grade: 5, value: false },
              { grade: 6, value: false },
              { grade: 7, value: false },
              { grade: 8, value: false },
              { grade: 9, value: false },
              { grade: 10, value: false },
            ],
          },
        ],
        level1: {
          email: null,
          days: null,
        },
        level2: {
          email: null,
          days: null,
        },
        level3: {
          email: null,
          days: null,
        },
      };
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/organisms/settings/settings-alert-rules/new-rule/index.vue